import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

export default function HotRecommend() {
  const hotComics = comics.filter((c) => c.rating >= 9.2).slice(0, 6);

  return (
    <section className="py-16 px-4 md:px-6 bg-background-100" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-10 gap-4">
          <div>
            <span className="text-sm text-foreground-400 font-label tracking-wider">EDITOR'S PICK</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mt-1">
              热门
              <span className="font-heading italic text-primary-500">推荐</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-md">
            精选评分最高、人气最旺的韩国漫画作品，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}